import { createContext, useCallback, useContext, useEffect, type ReactNode } from 'react';

type Theme = 'light';

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
  setTheme: (theme: Theme) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
}

const applyLightTheme = () => {
  const root = document.documentElement;
  root.classList.remove('dark');
  root.classList.add('light');
};

interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  useEffect(() => {
    applyLightTheme();
    localStorage.removeItem('paygatex_theme');
    localStorage.removeItem('paygatex-theme');
  }, []);

  const noop = useCallback(() => {}, []);

  return (
    <ThemeContext.Provider value={{ theme: 'light', toggleTheme: noop, setTheme: noop }}>
      {children}
    </ThemeContext.Provider>
  );
}
